import * as REQUEST_STATES from 'forms-utils-lib/RequestState';
import * as Actions from 'forms-utils-lib/dataPrivacySettings/actions/DataPrivacySettings';
export const INIT_STATE = {
  requestState: REQUEST_STATES.NOT_REQUESTED,
  gdprToggleEnabled: null,
  legalBasisRequirementEnabled: null
};
export const dataPrivacySettings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case Actions.REQUEST_DATA_PRIVACY_SETTINGS:
      return Object.assign({}, state, {
        requestState: REQUEST_STATES.REQUESTED
      });
    case Actions.RECEIVE_DATA_PRIVACY_SETTINGS:
      return Object.assign({}, state, {
        requestState: REQUEST_STATES.SUCCEEDED,
        gdprToggleEnabled: action.payload.gdprToggleEnabled,
        legalBasisRequirementEnabled: action.payload.legalBasisRequirementEnabled
      });
    case Actions.FAIL_DATA_PRIVACY_SETTINGS:
      return Object.assign({}, state, {
        requestState: REQUEST_STATES.FAILED
      });
    default:
      return state;
  }
};
export default dataPrivacySettings;